import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/saju/$sajuType')({
  component: SajuLayout,
})

function SajuLayout() {
  return <Outlet />
}
